import {lazy} from 'react'

export const ActivityFeedHandler = lazy(() => import('./../../../components/activity-feed'))

export const AssignmentsHandler = lazy(() => import('../../../components/assignments'))

export const DashboardHandler = lazy(() => import('../../../components/dashboard/handler'))

export const ChromelessErrorHandler = lazy(() => import('../../../components/chromeless-error'))

export const MobileReminderHandler = lazy(() => import('./../../../../pages/mobile-reminder'))

export const PricingHandler = lazy(() => import('./../../../../pages/pricing/components/'))

export const CheckoutHandler = lazy(() => import('./../../../../pages/checkout/components/'))

export const ReferralProgramHandler = lazy(
  () => import('./../../../../pages/referral-program/components/')
)

export const PremiumReferralProgramHandler = lazy(
  () => import('./../../../../pages/premium-referral-program/components/')
)

export const ProfileSettingsHandler = lazy(
  () => import('../../../../pages/settings/components/profile-settings-page')
)

export const ProductSettingsHandler = lazy(
  () => import('../../../../pages/settings/components/product-settings-page')
)

export const StudentGoalsHandler = lazy(() => import('./../../../../pages/student-goals'))

export const TeacherOnboardingHandler = lazy(
  () => import('./../../../components/teacher-onboarding')
)

export const ParentWelcomeHandler = lazy(() => import('./../../../components/parent-welcome'))

export const ReportsOverviewHandler = lazy(() => import('./../../../../pages/reports-overview'))

export const ChromelessPreview = lazy(() => import('./../../../../pages/chromeless-preview'))
